module.exports = __webpack_public_path__ + "img/b6230696ce53b4397cb6c6f354d85e46143c5767.68a5ffec.png";